import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import App from './views/App';

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID)

// render the App component to our document root with React
ReactDOM.render(<App />, document.getElementById('root'));
